import { adminAPIService } from './index'

const route = 'file'

export default {
  getList: (page = 1, size = 20) => {
    const params = {
      page,
      size,
    }

    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  upload: (file) => {
    const formData = new FormData()
    formData.append('file', file)

    return adminAPIService({
      url: `${route}/upload`,
      method: 'post',
      data: formData,
    })
  },
}
